import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'

interface AuthGuardProps {
  redirectTo?: string
  children?: React.ReactNode
}

export function AuthGuard({ redirectTo = '/welcome', children }: AuthGuardProps) {
  const { status, step } = useAuth()
  const location = useLocation()

  if (status === 'idle') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ textAlign: 'center', color: 'var(--ink-500)' }}>
          <div style={{ width: 32, height: 32, border: '3px solid var(--ink-200)', borderTopColor: 'var(--brand-pink)', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />
          Loading...
        </div>
      </div>
    )
  }

  if (status !== 'authenticated') {
    return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />
  }

  if (step === 'profile_completion' && location.pathname !== '/onboarding/owner') {
    return <Navigate to="/onboarding/owner" replace />
  }

  return children ? <>{children}</> : <Outlet />
}
